module.exports = __webpack_public_path__ + "img/pink75.c9c80bc6.png";